<section class="page">
  <header class="page-header">
    <div>
      <h1>Users</h1>
      <p>Tenant users and role assignments.</p>
    </div>
    <mat-form-field appearance="outline" class="search">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="searchText" (keyup.enter)="load()" />
      <button mat-icon-button matSuffix type="button" (click)="load()"><mat-icon>search</mat-icon></button>
    </mat-form-field>
  </header>

  @if (error()) { <div class="error">{{ error() }}</div> }
  @if (loading()) { <div class="loading"><mat-spinner diameter="36"></mat-spinner></div> }

  @if (selectedUserId() && canAssignRoles()) {
    <div class="assign-panel">
      <h3>Assign roles</h3>
      <mat-form-field appearance="outline" class="grow">
        <mat-label>Roles</mat-label>
        <mat-select multiple [(ngModel)]="selectedRoleIds">
          @for (r of roles(); track r.id) {
            <mat-option [value]="r.id">{{ r.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-flat-button color="primary" type="button" [disabled]="savingRoles()" (click)="saveRoles()">Save</button>
      <button mat-button type="button" (click)="selectedUserId.set(null)">Cancel</button>
    </div>
  }

  <table mat-table [dataSource]="users()" class="full">
    <ng-container matColumnDef="displayName"><th mat-header-cell *matHeaderCellDef>Name</th><td mat-cell *matCellDef="let u">{{ u.displayName || (u.firstName + ' ' + u.lastName) }}</td></ng-container>
    <ng-container matColumnDef="email"><th mat-header-cell *matHeaderCellDef>Email</th><td mat-cell *matCellDef="let u">{{ u.email }}</td></ng-container>
    <ng-container matColumnDef="status"><th mat-header-cell *matHeaderCellDef>Status</th><td mat-cell *matCellDef="let u">{{ u.status ?? '—' }}</td></ng-container>
    <ng-container matColumnDef="roles">
      <th mat-header-cell *matHeaderCellDef>Roles</th>
      <td mat-cell *matCellDef="let u">
        @for (role of roleNames(u); track role) {
          <mat-chip>{{ role }}</mat-chip>
        } @empty { <span class="muted">—</span> }
      </td>
    </ng-container>
    <ng-container matColumnDef="lastLoginAt"><th mat-header-cell *matHeaderCellDef>Last login</th><td mat-cell *matCellDef="let u">{{ u.lastLoginAt ? (u.lastLoginAt | date:'medium') : '—' }}</td></ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let u">
        @if (canAssignRoles()) {
          <button mat-button type="button" (click)="selectUser(u)">Assign roles</button>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns" [class.selected]="selectedUserId() === row.id"></tr>
  </table>
</section>
